/* eslint-disable no-plusplus */
/* eslint-disable prefer-template */
import DatePickerRangeG from "components/DatePickerRangeG";
import { MdOutlineModeEdit } from "react-icons/md";
import { BsFillTrash3Fill } from "react-icons/bs";
import { Skeleton, Tooltip } from "@mui/material";
import CustomPagination from "components/CustomPagination";
import { BiChevronRight } from "react-icons/bi";
import InputGrid from "screens/leads/components/InputGrid";
import { useState, useEffect } from "react";
import SelectComponent from "components/selectAutoCompleteG";
import { useGetGerarRelatorio } from "services/api/Common_Campanhas/get-gerar-relatorio";
import { RiFileExcel2Fill } from "react-icons/ri";
import { useHistory } from "react-router-dom";
import * as dateFns from "date-fns";
import { ptBR } from "date-fns/locale";
import { useGetFiltrarEquipes } from "services/api/Common_Campanhas/get-filtrar-equipes";
import { useGetFiltrarCampanhas } from "services/api/Common_Campanhas/get-filtrar-campanhas";
import { useGetListarCampanhas } from "services/api/Common_Campanhas/get-listar-campanhas";
import ModalCommon from "components/ModalCommon";
import { ModalDeletarCampanha } from "../ModalDeletarCampanha";
import CampanhasEmpty from "../CampanhasEmpty";
import * as S from "./styles";

interface Props {
  cargos: {
    isCorretor: boolean;
    isGerenteVendas: boolean;
    isSuperintendente: boolean;
  };
}

const CampanhasFilled: React.FC<Props> = ({ cargos }) => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  const [searchTerm, setSearchTerm] = useState("");
  const [appliedSearchTerm, setAppliedSearchTerm] = useState("");
  const [equipeValue, setEquipeValue] = useState<any>(null);
  const [campanhaValue, setCampanhaValue] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState<any>(null);
  const [dateTo, setDateTo] = useState<any>(null);
  const [idCampanha, setIdCampanha] = useState<string>("");

  const [openModalDeletarCampanha, setOpenModalDeletarCampanha] =
    useState<boolean>(false);

  const {
    data: campanhasData,
    refetch: campanhasRefetch,
    isFetching: isFetchingCampanhasData,
  } = useGetListarCampanhas({
    queryKey: `listar_campanhas_${currentPage}_${equipeValue?.value || ""}_${
      campanhaValue?.value || ""
    }_${appliedSearchTerm}`,
    PaginaAtual: currentPage,
    TotalItensRetorno: itemsPerPage,
    PalavrasChave: appliedSearchTerm,
    idEquipe: equipeValue?.value,
    idCampanha: campanhaValue?.value,
  });

  useEffect(() => {
    if (searchTerm === "") {
      setAppliedSearchTerm("");
      setCurrentPage(1);
    }
  }, [searchTerm]);

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const handleSearchEnter = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      setAppliedSearchTerm(searchTerm);
      setCurrentPage(1);
    }
  };

  const {
    data: dataGerarRelatorio,
    refetch: refetchGerarRelatorio,
    isFetching: isLoadingGerarRelatorio,
    isSuccess: isSuccessGerarRelatorio,
  } = useGetGerarRelatorio({
    queryKey: "gerar_relatorio_campanhas" + dateFrom + dateTo,
    InicioIntervaloCadastroCampanha:
      dateFrom && dateFns.isValid(dateFrom)
        ? dateFns.format(dateFrom, "yyyy-MM-dd")
        : "",
    FimIntervaloCadastroCampanha:
      dateTo && dateFns.isValid(dateTo)
        ? dateFns.format(dateTo, "yyyy-MM-dd")
        : "",
  });

  const downloadRelatorio = (base64Planilha: string) => {
    if (!base64Planilha) {
      console.error("Base64 da planilha não encontrado");
      return;
    }

    // Remove o prefixo "data:application/...;base64," se existir
    const base64String = base64Planilha.includes(",")
      ? base64Planilha.split(",")[1]
      : base64Planilha;

    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);

    const dataAtual = dateFns.format(new Date(), "dd-MM-yyyy_HH-mm-ss", {
      locale: ptBR,
    });
    const link = document.createElement("a");
    link.href = url;
    link.download = `relatorio_campanhas_${dataAtual}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (dataGerarRelatorio?.base64Planilha && isSuccessGerarRelatorio) {
      downloadRelatorio(dataGerarRelatorio.base64Planilha);
    }
  }, [dataGerarRelatorio, isSuccessGerarRelatorio]);

  const { data: dataFiltrarEquipes } = useGetFiltrarEquipes({
    queryKey: "filtrar_equipes",
  });

  const { data: dataFiltrarCampanhas } = useGetFiltrarCampanhas({
    queryKey: `filtrar_campanhas_${equipeValue?.value || "all"}`,
    idEquipe: equipeValue?.value,
  });

  const hasNoResults = campanhasData?.data?.listaCampanhas?.length === 0;
  const isEmpty =
    hasNoResults && !appliedSearchTerm && !equipeValue && !campanhaValue;

  if (isFetchingCampanhasData) {
    return (
      <>
        <Skeleton variant="rounded" width="100%" height={700} />
      </>
    );
  }

  if (isEmpty && (cargos.isGerenteVendas || cargos.isSuperintendente)) {
    return <CampanhasEmpty cargos={cargos} />;
  }

  return (
    <>
      <S.Container>
        <S.Header>
          <S.Title>CAMPANHAS</S.Title>
          <S.Line />
        </S.Header>

        <S.SearchContainer>
          {cargos.isGerenteVendas && (
            <InputGrid
              style={{ width: "300px", marginTop: "24px" }}
              variant="outlined"
              value={searchTerm}
              onChange={(e: any) => setSearchTerm(e.target.value)}
              onKeyDown={handleSearchEnter}
              handleBtnSearch={() => {}}
            />
          )}
          {cargos.isSuperintendente && (
            <>
              <div style={{ display: "flex", gap: "16px" }}>
                <SelectComponent
                  width="200px"
                  label="Filtrar Equipe"
                  onChange={(newValue: any) => {
                    setEquipeValue(newValue);
                    setCampanhaValue(null);
                    setCurrentPage(1);
                  }}
                  value={equipeValue}
                  placeholder="Todas"
                  data={
                    dataFiltrarEquipes?.lideres?.map((empreendimento: any) => ({
                      label: empreendimento?.nomeEquipe,
                      value: empreendimento?.idEquipe,
                    })) ?? []
                  }
                />
                <SelectComponent
                  width="200px"
                  label="Filtrar Campanha"
                  onChange={(newValue: any) => {
                    setCampanhaValue(newValue);
                    setCurrentPage(1);
                  }}
                  value={campanhaValue}
                  placeholder="Todos"
                  data={
                    dataFiltrarCampanhas?.campanhas?.map((campanha: any) => ({
                      label: campanha?.nomeCampanha,
                      value: campanha?.idCampanha,
                    })) ?? []
                  }
                />
              </div>
            </>
          )}
          <S.RelatorioSection>
            <S.Row>
              <DatePickerRangeG
                startDate={dateFrom}
                endDate={dateTo}
                onStartDateChange={setDateFrom}
                onEndDateChange={setDateTo}
                width="350px"
                minDate={dateFrom}
              />
              <S.SpaceX space={12} />
              <S.Column>
                <S.GerarRelatorioButton
                  onClick={() => refetchGerarRelatorio()}
                  disabled={!dateFrom || !dateTo || isLoadingGerarRelatorio}
                >
                  <RiFileExcel2Fill color="#4CAF50" width="30" height="30" />
                  {isLoadingGerarRelatorio ? "Gerando..." : "Gerar Relatório"}
                </S.GerarRelatorioButton>
              </S.Column>
            </S.Row>
          </S.RelatorioSection>
          <S.ContactCount>
            <S.ContactCountText>
              {campanhasData?.data?.quantidadeContatosBaseDados}{" "}
              <strong>contatos</strong>
            </S.ContactCountText>{" "}
            <S.ContactInfoText>
              remanescentes na base de dados
            </S.ContactInfoText>
          </S.ContactCount>
        </S.SearchContainer>

        <S.Table>
          <thead>
            <tr>
              {cargos.isSuperintendente && <S.Th>Equipe</S.Th>}
              <S.Th>Nome da Campanha</S.Th>
              <S.Th>Início</S.Th>
              <S.Th>Contatos selecionados</S.Th>
              <S.Th>Contatos restantes</S.Th>
              <S.Th>Status</S.Th>
              {cargos.isGerenteVendas && <S.Th>Ações</S.Th>}
              {cargos.isSuperintendente && <S.Th />}
            </tr>
          </thead>
          <tbody>
            {campanhasData?.data?.listaCampanhas?.map((campanha: any) => (
              <tr key={campanha?.id}>
                {cargos.isSuperintendente && (
                  <S.Td>
                    <S.ProjectCell>
                      <S.ProjectImage
                        src={campanha?.fotoEquipe}
                        alt={campanha?.fotoEquipe}
                      />
                      <Tooltip
                        title={campanha?.nomeEquipe}
                        placement="top"
                        arrow
                      >
                        <S.ProjectName>{campanha?.nomeEquipe}</S.ProjectName>
                      </Tooltip>
                    </S.ProjectCell>
                  </S.Td>
                )}
                <S.Td>{campanha?.nome}</S.Td>
                {/* remove conflito */}
                <S.Td>{campanha?.dataInicio}</S.Td>
                <S.Td>{campanha?.contatosSelecionados}</S.Td>
                <S.Td>{campanha?.contatosRestantes}</S.Td>
                <S.Td>
                  <S.Status>{campanha?.ativo ? "Ativa" : "Inativa"}</S.Status>
                </S.Td>
                {cargos.isGerenteVendas && (
                  <S.Td>
                    <S.ActionsCell>
                      <S.ActionButton
                        onClick={() => {
                          history.push(`/campanha/${campanha?.id}`);
                        }}
                      >
                        <MdOutlineModeEdit />
                      </S.ActionButton>
                      <S.ActionButton
                        onClick={() => {
                          setOpenModalDeletarCampanha(true);
                          setIdCampanha(campanha?.id);
                        }}
                      >
                        <BsFillTrash3Fill />
                      </S.ActionButton>
                    </S.ActionsCell>
                  </S.Td>
                )}
                {cargos.isSuperintendente && (
                  <S.Td>
                    <BiChevronRight
                      onClick={() => {
                        history.push(`/campanha/${campanha?.id}`);
                      }}
                      style={{
                        color: "#00000099",
                        width: "30px",
                        height: "30px",
                        cursor: "pointer",
                      }}
                    />
                  </S.Td>
                )}
              </tr>
            ))}
          </tbody>
        </S.Table>

        <S.Pagination>
          <CustomPagination
            count={campanhasData?.pagination?.quantityPages || 1}
            page={currentPage}
            onPageChange={(
              event: React.MouseEvent<HTMLButtonElement>,
              page: number
            ) => handlePageChange(event, page)}
          />
        </S.Pagination>
        {cargos.isGerenteVendas && (
          <S.NewCampaignButton to="/criar-campanha">
            NOVA CAMPANHA
          </S.NewCampaignButton>
        )}
      </S.Container>
      <ModalCommon
        open={openModalDeletarCampanha}
        setOpenModal={setOpenModalDeletarCampanha}
        onClose={() => {
          setOpenModalDeletarCampanha(false);
        }}
      >
        <ModalDeletarCampanha
          onClose={() => {
            setOpenModalDeletarCampanha(false);
          }}
          campanhasRefetch={campanhasRefetch}
          idCampanha={idCampanha}
        />
      </ModalCommon>
    </>
  );
};

export default CampanhasFilled;
